//Install
import React, { Component } from "react";
//Install
import { Container, Row, Col } from "react-bootstrap";
//Install
import Header from "../../../Uk/Header";
//Install
import Footer from "../../../Uk/Footer";
//Install
import Q96F2K from "../../../Uk/Content/Country/Q96F2K";
//Install
import M42V32 from "../../../Uk/Content/Country/M42V32";
//Install
import Y477FT from "../../../../../Media/Image/019.jpg";

//Element
class Default extends Component {
    //Element
    componentDidMount() {
        //Element
        document.title = "Offices : Temas Electrical Contracting"
        //Element
        document.getElementsByTagName("meta")["description"].content = "Delivering Sustainable and Reliable Energy Solutions That Empower The Future."
        //Element
        let URL = "https://en.temaselektrik.com/offices"
        //Element
        let Canonical = document.querySelector("link[rel='canonical']")
        //Element
        Canonical.setAttribute("href", URL);
    }
    //Element
    render() {
        //Element
        const Content = React.createElement("div", { className: "website-application" },
            //Element
            React.createElement(Header, {}),
            //Element
            React.createElement("main", { className: "S6pt64 C96Q4r pEO064 a527eB d3c437" },
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB f1d74t" },
                    //Element
                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB p33e0e" },
                        //Element
                        React.createElement("figure", { className: "S6pt64 C96Q4r pEO064 a527eB i457do" })
                    )
                ),
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB gq620v" },
                    //Element
                    React.createElement(Container, {},
                        //Element
                        React.createElement(Row, {},
                            //Element
                            React.createElement(Col, { md: 12 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB v431h7" },
                                    //Element
                                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB yk8549" },
                                        //Element
                                        React.createElement("h1", { className: "S6pt64 C96Q4r pEO064 a527eB u7760y" },
                                            //Element
                                            "Offices"
                                        )
                                    )
                                )
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB q95k0u" },
                                    //Element
                                    React.createElement("h2", { className: "S6pt64 C96Q4r pEO064 a527eB q887o2" },
                                        //Element
                                        "We Transport Energy ",
                                        //Element
                                        React.createElement("strong", {},
                                            //Element
                                            "From"
                                        ),
                                        //Element
                                        " Turkey to Azerbaijan"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Temas Electrical Contracting Limited Company, with its branches in Turkey and Azerbaijan, provides fast, reliable, and high-quality services to its clients in every region."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Through our extensive operational network, we provide on-site and effective solutions to all our clients, from public institutions and industrial facilities to SMEs and private projects."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Each of our branches represents Temas Electrical Contracting expert team and innovative approach, ensuring quality and reliability at every stage of your projects."
                                    )
                                )
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement("picture", { className: "S6pt64 C96Q4r pEO064 a527eB e649gp" },
                                    //Element
                                    React.createElement("img", { alt: "Offices", title: "Offices", src: Y477FT, width: "636", height: "auto" })
                                )
                            )
                        )
                    )
                ),
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB d44n75" },
                    //Element
                    React.createElement(Container, {},
                        //Element
                        React.createElement(Row, {},
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement(M42V32, {})
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement(Q96F2K, {})
                            )
                        )
                    )
                )
            ),
            //Element
            React.createElement(Footer, {})
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Default;